import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction, WithServiceId } from '@mews-commander/types';
import {
    canCurrentEmployeeManageReservations,
    canCurrentEmployeeUseTimeline,
    isCurrentProfileEnabledToManageCustomers,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getCurrentEnterpriseChainId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getCustomerCreateUrl, getHomeUrl, getReservationOverviewUrl, getReservationUrl } from '../../router/selectors';
import { ReservationTab } from '../../types/reservationTab';
import { navigateInBaseModal, openModal } from '../app/actions/common';
import { showReservationDetail } from '../routes';
import { showTimeline } from '../timeline/routes';

export const navigateToTimeline =
    ({ serviceId }: WithServiceId): CommanderThunkAction =>
    (dispatch, getState) => {
        if (canCurrentEmployeeUseTimeline(getState())) {
            dispatch(showTimeline({ serviceId }));
        }
    };

export const navigateToReservationOverview =
    ({ mode }: $TSFixMe = {}): CommanderThunkAction =>
    (dispatch, getState) => {
        if (canCurrentEmployeeManageReservations(getState())) {
            const url = getReservationOverviewUrl(getState(), { mode });
            dispatch(navigateInBaseModal(url));
        }
    };

export const navigateToHome =
    (): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = getHomeUrl(getState(), { resolveRoute });

        dispatch(navigateInBaseModal(url));
    };

export const navigateToResourceStatusReport =
    (): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const url = resolveRoute(RouteName.ResourceStatusReportIndex);
        dispatch(navigateInBaseModal(url));
    };

export const navigateToNRS = (): CommanderThunkAction => (dispatch, getState) => {
    if (canCurrentEmployeeManageReservations(getState())) {
        const url = getReservationUrl(getState(), {});
        dispatch(openModal(url));
    }
};

export const navigateToNewCustomerScreen = (): CommanderThunkAction => (dispatch, getState) => {
    if (isCurrentProfileEnabledToManageCustomers(getState())) {
        const url = getCustomerCreateUrl(getState(), {
            chainId: getCurrentEnterpriseChainId(getState()),
            lastName: '',
        });
        dispatch(openModal(url));
    }
};

export const navigateToNewCompanyScreen =
    (): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        if (isCurrentProfileEnabledToManageCustomers(getState())) {
            const enterpriseChainId: string = getCurrentEnterpriseChainId(getState());
            const url = resolveRoute(RouteName.CompanyCreate, {
                query: {
                    ownerId: enterpriseChainId,
                },
            });
            dispatch(openModal(url));
        }
    };

export const navigateToReservationDetail =
    (id: string): CommanderThunkAction =>
    (dispatch, getState) => {
        if (canCurrentEmployeeManageReservations(getState())) {
            dispatch(showReservationDetail({ reservationId: id, reservationTab: ReservationTab.Status }));
        }
    };

export const navigateToResourceState =
    (id: string): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        if (canCurrentEmployeeManageReservations(getState())) {
            const url = resolveRoute(RouteName.ResourceState, { id });
            dispatch(openModal(url));
        }
    };
